module.exports = __webpack_public_path__ + "89a67b4c673c4f22ef472aeb3fa304bc.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/backgrounds/food.png
// module id = 3363
// module chunks = 0